/**
 * BlueDolphin Loader component
 *
 * @returns {JSX.Element}
 */
export default function Loader() {
    return (
        <img
            alt="blue dolphin gif"
            className="loader"
            src="https://cdn.bluedolphin.valueblue.nl/images/dolphinloader.gif"
        />
    );
}
